var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home p-4"},[_c('div',{staticClass:"container"},[_c('MessagesNav'),_c('MessagesList',{attrs:{"messages":_vm.messages}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }